import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702fa7e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-bullhorn me-2" }),
    /*#__PURE__*/_createTextVNode("ผลการแก้ไขเรื่องราวร้องทุกข์")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "รายงานผลการแก้ไขเรื่องราวร้องทุกข์ในพื้นที่")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search me-2" }, null, -1))
const _hoisted_13 = { class: "card card-sub mb-3" }
const _hoisted_14 = { class: "card-body p-2" }
const _hoisted_15 = { class: "list-group list-group-flush" }
const _hoisted_16 = { class: "list-group-item" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "จำนวนเรื่องทั้งหมด:", -1))
const _hoisted_19 = { class: "col text-end" }
const _hoisted_20 = { class: "list-group-item" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "กำลังดำเนินการ:", -1))
const _hoisted_23 = { class: "col text-end" }
const _hoisted_24 = { class: "list-group-item" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "เสร็จสิ้นแล้ว:", -1))
const _hoisted_27 = { class: "col text-end" }
const _hoisted_28 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_29 = {
  ref: "datatable",
  class: "table table-striped"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จังหวัด"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ทั้งหมด"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "กำลังดำเนินการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "เสร็จสิ้นแล้ว")
  ])
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle me-2" }, null, -1))
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", {
              for: "dateFrom",
              class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.dateFrom}])
            }, " วันที่เริ่มต้น: ", 2),
            (_ctx.submited && _ctx.errors.dateFrom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " * กรุณาเลือกวันที่เริ่มต้น "))
              : _createCommentVNode("", true),
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.formData.dateFrom,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dateFrom) = $event)),
              enableTimePicker: false,
              locale: "th-TH",
              format: "dd/MM/yyyy",
              weekStart: "0",
              position: "left",
              autoApply: "",
              placeholder: "กรุณาเลือกวันที่เริ่มต้น...",
              class: _normalizeClass(["form-control p-0", {'is-invalid': _ctx.submited && _ctx.errors.dateFrom}]),
              onChange: _ctx.unsubmit
            }, null, 8, ["modelValue", "class", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              for: "dateTo",
              class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.dateTo}])
            }, " วันที่สิ้นสุด: ", 2),
            (_ctx.submited && _ctx.errors.dateTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " * กรุณาเลือกวันที่สิ้นสุด "))
              : _createCommentVNode("", true),
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.formData.dateTo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dateTo) = $event)),
              enableTimePicker: false,
              locale: "th-TH",
              format: "dd/MM/yyyy",
              weekStart: "0",
              position: "left",
              autoApply: "",
              placeholder: "กรุณาเลือกวันที่สิ้นสุด...",
              class: _normalizeClass(["form-control p-0", {'is-invalid': _ctx.submited && _ctx.errors.dateTo}]),
              onChange: _ctx.unsubmit
            }, null, 8, ["modelValue", "class", "onChange"])
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary mb-4",
        type: "button",
        disabled: _ctx.isLoading,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchClick && _ctx.searchClick(...args)))
      }, [
        _hoisted_12,
        _createTextVNode("ตกลง ")
      ], 8, _hoisted_11),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(Number(_ctx.result.total).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + " เรื่อง", 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(Number(_ctx.result.inprogress).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + " เรื่อง", 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(Number(_ctx.result.done).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + " เรื่อง", 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pscs, (psc, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, [
                      _hoisted_31,
                      _createTextVNode(_toDisplayString(psc.org_name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(Number(psc.count_total).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })), 1),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(Number(psc.count_inprogress).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(Number(psc.count_done).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })), 1)
                  ]))
                }), 128))
              ])
            ], 512)
          ]))
    ])
  ]))
}